// import React from "react";
// import { MDBIcon } from "mdb-react-ui-kit";
// import "../styles/pages/aboutus.css";
// import About2 from "../media/about-2.jpg"
// import kitchen from "../media/kitchen.jpg"
// import chef from "../media/chef.jpeg"
// import SubHome from "../components/SubHome";

// const AboutUs = () => {
//   const values = [
//     { icon: "lightbulb", title: "Innovation", text: "We use technology to enhance culinary experiences." },
//     { icon: "utensils", title: "Quality", text: "Every dish is crafted to meet unique preferences." },
//     { icon: "hand-holding-heart", title: "Empowerment", text: "Empowering cooks and diners alike." },
//     { icon: "shield-alt", title: "Trust & Safety", text: "Safe interactions and secure payments." },
//     { icon: "leaf", title: "Sustainability", text: "Promoting fresh, local, and sustainable practices." },
//   ];

//   return (

// <>
// <SubHome mainHeading="About Us" listItem="About" />
// <div className="about-us">
//       {/* <div className="hero">
//         <div className="hero-overlay">
//           <h1>Welcome to Cheffy</h1>
//           <p>Personalized dining, crafted just for you.</p>
//           <button className="cta-button">Explore Now</button>
//         </div>
//       </div> */}

//       <section className="about-section">
//         <div className="about-content">
//           <div className="about-image">
//             <img src={About2} alt="About us" />
//           </div>
//           <div className="about-text">
//             <h2>About Us</h2>
//             <p>
//             At Cheffy, we believe the best dining experience is one that's enjoyed at home, personalized, and cooked just for you. We are a tech platform that connects passionate cooks (cookers) with people looking for a unique, in-home culinary experience (eaters). Whether you want to enjoy a home-cooked meal, try an exotic dish, or simply relax while someone else takes care of the cooking, Cheffy is here to make it happen.
//             </p>
//             <p>Our team is made up of young innovators who blend technology with gastronomy to transform the way people eat. With just a few clicks, you can post a meal request, and one of our cookers will come to your home to prepare exactly what you crave. We believe in convenience, quality, and the personal touch behind every meal.</p>
//           </div>
//         </div>
//       </section>

//       <section className="mission-section">
//         <h2>Our Mission</h2>
//         <p>
//           To democratize personalized gastronomy, making unique meals accessible and prepared with passion.
//         </p>
//         <img src={chef} alt="Mission" />
//       </section>

//       <section className="vision-section">
//         <div className="vision-content">
//           <div className="vision-text">
//             <h2>Our Vision</h2>
//             <p>
//             our vision is to lead the future of at-home dining experiences, becoming the number one platform where cooks and food lovers meet. We envision a world where every meal is designed just for you, prepared with care and without hassle. We aim to empower both cooks and diners through a global, accessible, and sustainable culinary experience.
//             </p>
//           </div>
//           <div className="vision-image">
//             <img src={kitchen} alt="Vision" />
//           </div>
//         </div>
//       </section>

//       <section className="values-section">
//         <h2>Our Values</h2>
//         <div className="values-grid">
//           {values.map((value, index) => (
//             <div key={index} className="value-card">
//               <MDBIcon fas icon={value.icon} className="icon" />
//               <h3>{value.title}</h3>
//               <p>{value.text}</p>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
// </>

//   );
// };

// export default AboutUs;

import React from "react";
import { MDBIcon } from "mdb-react-ui-kit";
import "../styles/pages/aboutus.css";
import About2 from "../media/about-2.jpg";
import kitchen from "../media/kitchen.jpg";
import chef from "../media/chef.jpeg";
import SubHome from "../components/SubHome";
import Footer from "../components/Footer";
const AboutUs = () => {
  const values = [
    {
      icon: "lightbulb",
      title: "Innovación",
      text: "La tecnología está en el corazón de Cheffy. Creemos en el poder de las herramientas digitales para simplificar y enriquecer las experiencias culinarias, creando conexiones significativas entre cookers y eaters.",
    },
    {
      icon: "utensils",
      title: "Calidad y Personalización",
      text: "Cada platillo preparado a través de Cheffy es único. Priorizamos la calidad en cada bocado, adaptándonos a las preferencias y necesidades específicas de nuestros clientes.",
    },
    {
      icon: "hand-holding-heart",
      title: "Empoderamiento",
      text: "Cheffy ofrece una plataforma que empodera tanto a los cocineros, dándoles la oportunidad de monetizar sus habilidades, como a los comensales, quienes pueden disfrutar de una experiencia gastronómica personalizada.",
    },
    {
      icon: "shield-alt",
      title: "	Confianza y Seguridad",
      text: "Nos aseguramos de que cada interacción en nuestra plataforma sea segura y confiable, desde la verificación de los cookers hasta los pagos seguros.",
    },
    {
      icon: "leaf",
      title: "Sostenibilidad",
      text: "Creemos en un futuro más sostenible, donde la comida local y los ingredientes frescos sean accesibles para todos, promoviendo prácticas que reduzcan el desperdicio y apoyen las economías locales.",
    },
  ];

  return (
    <>
      <SubHome mainHeading="Sobre Nosotros" listItem="Sobre Nosotros" />
      <div className="about-container">
        <div className="about-sub">
          <div className="about-row col-row">
            <div className="col">
              <div className="heading-content-section">
                <h6 className="main-sub-heading">Nuestra historia de origen:</h6>
                <h2 className="main-heading">Quienes somos</h2>
                <div
                  className="heading-border"
                  style={{ marginBottom: "40px" }}
                ></div>
              </div>
              <div className="text-info-section">
                <p className="text-sec">
                  En Cheffy, creemos que la mejor experiencia gastronómica es
                  aquella que se disfruta en casa, personalizada y cocinada
                  especialmente para ti. Somos una plataforma tecnológica que
                  conecta a cocineros apasionados (cookers) con personas que
                  buscan una experiencia culinaria única en el hogar (eaters).
                  Ya sea que quieras disfrutar de una comida casera, probar un
                  platillo exótico o simplemente relajarte mientras alguien más
                  se encarga de cocinar, Cheffy está aquí para hacerlo realidad.
                </p>
                <p className="text-sec">
                  Nuestro equipo está compuesto por jóvenes innovadores que
                  combinan tecnología con gastronomía para transformar la manera
                  en que las personas comen. Con solo unos clics, puedes
                  publicar una solicitud de comida y uno de nuestros cookers
                  llegará a tu hogar para preparar exactamente lo que deseas.
                  Creemos en la comodidad, la calidad y el toque personal detrás
                  de cada comida.
                </p>
                {/* <ul className="about-list">
                  <li className="about-list-item">
                    <span className="about-list-icon">
                      <CheckIcon
                        style={{
                          fontSize: "28px",
                          fontWeight: "bold",
                          color: "#d1ad3c",
                        }}
                      />
                    </span>
                    Our global reach extends to students from diverse
                    backgrounds, fostering a rich and inclusive Islamic
                    community.
                  </li>
                  <li className="about-list-item">
                    <span className="about-list-icon">
                      <CheckIcon
                        style={{
                          fontSize: "28px",
                          fontWeight: "bold",
                          color: "#d1ad3c",
                        }}
                      />
                    </span>
                    Through the dedication of our tutors and the enthusiasm of
                    our learners, we collectively leave a meaningful imprint on
                    the hearts and minds of our students.
                  </li>
                  <li className="about-list-item">
                    <span className="about-list-icon">
                      <CheckIcon
                        style={{
                          fontSize: "28px",
                          fontWeight: "bold",
                          color: "#d1ad3c",
                        }}
                      />
                    </span>
                    Within the close-knit environment of Quran Tutor, every
                    member is valued, contributing to our shared vision with
                    unwavering commitment and unity.
                  </li>
                </ul> */}
              </div>
            </div>
            <div className="col-img">
              <img src={About2} alt="" className="about-img-top" />
            </div>
          </div>
          <div className="about-row reverse-colm">
            <div className="col-img">
              <img src={chef} alt="" className="about-img-bottom" />
            </div>
            <div className="col">
              <div className="heading-content-section">
                {/* <h6 className="main-sub-heading">Quran Online Classes</h6> */}
                <h2 className="main-heading">nuestra Misión</h2>
                <div
                  className="heading-border"
                  style={{ marginBottom: "40px" }}
                ></div>
              </div>
              <div className="text-info-section">
                <p className="text-sec">
                  Nuestra misión es democratizar la gastronomía personalizada,
                  haciendo que cada comida sea accesible, única y preparada con
                  pasión. A través de la tecnología, conectamos a personas con
                  cocineros talentosos, permitiendo a los eaters disfrutar de
                  platos hechos a medida desde la comodidad de su hogar,
                  mientras brindamos a los cookers la oportunidad de compartir
                  sus habilidades culinarias y crecer profesionalmente.
                </p>
              </div>
            </div>
          </div>
          <div className="about-row col-row">
            <div className="col">
              <div className="heading-content-section">
                <h2 className="main-heading">nuestra Visión</h2>
                <div
                  className="heading-border"
                  style={{ marginBottom: "40px" }}
                ></div>
              </div>
              <div className="text-info-section">
                <p className="text-sec">
                  Nuestra visión es liderar el futuro de las experiencias
                  gastronómicas en el hogar, convirtiéndonos en la plataforma
                  número uno donde cocineros y amantes de la comida se
                  encuentran. Imaginamos un mundo donde cada comida esté
                  diseñada especialmente para ti, preparada con cuidado y sin
                  complicaciones. Nuestro objetivo es empoderar tanto a
                  cocineros como a comensales a través de una experiencia
                  culinaria global, accesible y sostenible.
                </p>
              </div>
            </div>
            <div className="col-img">
              <img src={kitchen} alt="" className="about-img-top" />
            </div>
          </div>
        </div>
        <div className="values-section">
          <div className="heading-content-section">
            <h2 className="main-heading">Nuestros Valoress</h2>
            <div
              className="heading-border"
              style={{ marginBottom: "40px" }}
            ></div>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <MDBIcon fas icon={value.icon} className="icon" />
                <h3>{value.title}</h3>
                <p>{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
